/**
 * 布局/视口指标快照，供 DBG 浮窗 useSyncExternalStore 订阅（排查左侧滚动区被撑高等）。
 */

export type LayoutBoxSlice = {
  id: string;
  clientWidth: number;
  clientHeight: number;
  scrollWidth: number;
  scrollHeight: number;
  offsetWidth: number;
  offsetHeight: number;
  scrollTop: number;
  scrollLeft: number;
};

export type LayoutDebugData = {
  ts: string;
  path: string;
  windowInner: { width: number; height: number; dpr: number };
  documentElement: { clientWidth: number; clientHeight: number };
  /** 可选：Chrome performance.memory */
  memory?: { usedJSHeapSize?: number; totalJSHeapSize?: number; jsHeapSizeLimit?: number };
  leftScroll?: LayoutBoxSlice;
  storeContent?: LayoutBoxSlice;
};

export type LayoutDebugSnapshot =
  | { kind: "empty" }
  | { kind: "ready"; data: LayoutDebugData };

let snapshot: LayoutDebugSnapshot = { kind: "empty" };
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((fn) => fn());
}

export function setLayoutDebugData(data: LayoutDebugData | null): void {
  snapshot = data ? { kind: "ready", data } : { kind: "empty" };
  notify();
}

export function subscribeLayoutDebug(onStoreChange: () => void): () => void {
  listeners.add(onStoreChange);
  return () => {
    listeners.delete(onStoreChange);
  };
}

export function getLayoutDebugSnapshot(): LayoutDebugSnapshot {
  return snapshot;
}

export function sliceElement(el: HTMLElement, id: string): LayoutBoxSlice {
  return {
    id,
    clientWidth: el.clientWidth,
    clientHeight: el.clientHeight,
    scrollWidth: el.scrollWidth,
    scrollHeight: el.scrollHeight,
    offsetWidth: el.offsetWidth,
    offsetHeight: el.offsetHeight,
    scrollTop: el.scrollTop,
    scrollLeft: el.scrollLeft,
  };
}
